import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "myCustomStyles relative" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", { class: "text-black font-medium force-font" }, /*#__PURE__*/ _toDisplayString("Back"), -1);
const _hoisted_3 = {
    id: "dropdowns",
    style: { "display": "flex", "width": "100%", "height": "100vh", "background-color": "#ffffff" }
};
const _hoisted_4 = {
    id: "left-section",
    style: { "width": "25vw", "margin-top": "109px" }
};
const _hoisted_5 = {
    id: "internal-left-section",
    class: "pt-3 py-2 ml-10",
    style: { "width": "75%" }
};
const _hoisted_6 = { class: "pt-3 checkbox-group" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", null, "Call to Action For Payment Link Button", -1);
const _hoisted_8 = {
    key: 0,
    class: "pt-2"
};
const _hoisted_9 = { class: "text-sm text-gray-500 mb-1 pt-3" };
const _hoisted_10 = { class: "inline-flex items-center" };
const _hoisted_11 = { class: "mr-2 text-sm text-gray-700" };
const _hoisted_12 = { class: "ml-2 text-sm text-gray-700" };
const _hoisted_13 = {
    id: "right-section",
    style: { "width": "75vw", "margin-top": "59px" },
    class: "bg-gray-50"
};
const _hoisted_14 = {
    style: { "margin-top": "40px" },
    class: "ml-8"
};
const _hoisted_15 = { class: "flex justify-center items-center mt-6" };
const _hoisted_16 = { class: "flex flex-col md:!flex-row md:shadow-lg w-full max-w-6xl lg:py-10 bg-white" };
const _hoisted_17 = {
    id: "product-details-preview",
    style: { "flex": "0.5" },
    class: "p-6 md:pl-8 lg:border-r flex flex-col justify-between gap-2"
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "text-gray-500 product-details mb-2" }, "Product Details", -1);
const _hoisted_19 = {
    id: "product-name",
    class: "text-gray-500"
};
const _hoisted_20 = {
    key: 0,
    id: "product-price",
    class: "text-5xl font-bold mt-4 mb-4 text-gray-800 flex items-center gap-2"
};
const _hoisted_21 = {
    key: 0,
    class: "text-sm font-normal text-gray-500 inline-block text-left"
};
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_23 = { key: 1 };
const _hoisted_24 = {
    id: "trial-period-details",
    class: "text-5xl mt-4 mb-4 font-bold text-gray-800"
};
const _hoisted_25 = { class: "text-gray-800" };
const _hoisted_26 = {
    key: 2,
    id: "product-price-post-trial",
    class: "mb-2"
};
const _hoisted_27 = ["src", "alt"];
const _hoisted_28 = {
    key: 0,
    class: "text-gray-500 text-xs md:block"
};
const _hoisted_29 = { class: "flex-[0.5] right-section p-6 md:pr-8 !overflow-y-auto max-h-[70vh]" };
const _hoisted_30 = { id: "payment-link-form" };
const _hoisted_31 = {
    style: { "display": "flex" },
    cl: ""
};
const _hoisted_32 = { style: { "flex": "0.5", "padding-right": "5px" } };
const _hoisted_33 = { style: { "flex": "0.5" } };
const _hoisted_34 = {
    key: 1,
    class: "address-info-group"
};
const _hoisted_35 = {
    style: { "display": "flex" },
    cl: ""
};
const _hoisted_36 = { style: { "flex": "0.5", "padding-right": "5px" } };
const _hoisted_37 = { style: { "flex": "0.5" } };
import { useEmitter } from "@/composition/useEmitter";
import { payButtonOptions } from "@/helper";
import { InvoiceService, UrlType } from "@/services/InvoiceService";
import { PaymentServices } from "@/services/PaymentService";
import { ProductService } from '@/services/ProductService';
import { useMainStore } from "@/store/main";
import { ChevronLeftIcon, Save01Icon } from "@gohighlevel/ghl-icons/24/outline";
import { UIPaymentElement } from '@gohighlevel/ghl-payment-element';
import { UIButton, UICheckbox, UIForm, UIFormItem, UIInput, UIInputPhone, UISelect, UISwitch, UITextLgMedium, UITextSmNormal, UITextXsRegular, UIToolbar, UIToolbarGroup, useNotification } from '@gohighlevel/ghl-ui';
import { computed, inject, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PaymentLinksEditor',
    setup(__props) {
        const { t } = useI18n();
        const notification = useNotification();
        const store = useMainStore();
        const emitter = useEmitter();
        const router = inject('router');
        const route = inject('route');
        const rootStore = inject('store');
        // TODO - Move everything to formvalue in the next iteration
        const liveMode = ref(true);
        const showCustomerAddresses = ref(false);
        const showPhoneNumber = ref(false);
        const isBrandingPresent = ref(true);
        const formValue = ref({});
        const productsData = ref([]);
        const selectedProduct = ref({});
        const selectedPrice = ref({});
        const paymentLinkName = ref('New Link');
        const selectedPayButton = ref(payButtonOptions[0]);
        const paymentElementEnv = ref(process.env.NODE_ENV);
        function goBack() {
            router.push({ name: 'payment-links', params: { locationId: store.altId } });
        }
        const stripeOptions = ref({
            mode: 'payment',
            amount: 1000,
            currency: 'usd'
        });
        const prices = computed(() => {
            return selectedProduct.value.prices || [];
        });
        function updateCustomTextPresent(value) {
            isBrandingPresent.value = value;
            if (!formValue.value?.branding) {
                formValue.value.branding = `Powered by ${rootStore.state.locations?.currentLocation?.name}`.substring(0, 40);
            }
        }
        const selectedPriceSymbol = ref('');
        watch(() => selectedPrice.value, (newSelectedPrice, oldSelectedPrice) => {
            selectedPriceSymbol.value = store.currencyDetails?.currency[newSelectedPrice?.currency]?.symbol || '';
        });
        function onClickPrice(id, price) {
            selectedPrice.value = price;
        }
        function onClickProduct(id, product) {
            selectedProduct.value = product;
            if (selectedProduct.value.prices.length == 1) {
                selectedPrice.value = selectedProduct.value.prices[0];
            }
            else {
                selectedPrice.value = {};
            }
        }
        const productImage = computed(() => {
            if (!selectedProduct.value.name || !selectedProduct.value.medias?.length)
                return '';
            const images = selectedProduct.value.medias;
            const featuredProduct = images.find(img => img.isFeatured);
            return featuredProduct ? featuredProduct.url : images[0].url;
        });
        function updatePaymentLinkName(value) {
            paymentLinkName.value = value;
        }
        function updateLiveMode(value) {
            liveMode.value = value;
        }
        function onPaymentCallback() {
        }
        function captureCustomerAddresses(checked) {
            showCustomerAddresses.value = checked;
        }
        function capturePhoneNumber(checked) {
            showPhoneNumber.value = checked;
        }
        function updatePayButton(value, selectedPayObject) {
            if (selectedPayObject === null)
                return;
            selectedPayButton.value = selectedPayObject;
        }
        async function getProducts() {
            try {
                const { data } = await ProductService.getProducts({
                    locationId: store.altId,
                    limit: 100,
                });
                productsData.value = data.products;
            }
            catch (error) {
                console.log("Error in trying to retrieve products : ", error);
            }
        }
        const products = computed(() => {
            return productsData.value.map((product) => {
                const prices = product.prices;
                if (!prices?.length)
                    return false;
                return {
                    ...product,
                    label: product.name,
                    value: product._id,
                    disabled: false,
                    prices: prices.map((price) => {
                        return {
                            label: price.name,
                            value: price._id,
                            disabled: false,
                            ...price,
                        };
                    }),
                };
            })
                .filter(Boolean);
        });
        async function getPaymentLinkUrl(paymentLinkId) {
            // get payment url from api
            try {
                const { data } = await InvoiceService.generateUrl({
                    id: paymentLinkId,
                    type: UrlType.PAYMENT_LINK,
                    shortUrl: false,
                });
                return data?.url;
            }
            catch (err) {
                console.error(err);
            }
        }
        async function onClickPreview() {
            if (!validatePaymentLinkConfig())
                return;
            notification.success({
                content: 'Saving your payment link first',
                duration: 3000,
                keepAliveOnHover: false
            });
            const paymentLinkId = await onClickSave(true);
            const redirectUrl = await getPaymentLinkUrl(paymentLinkId);
            if (route.params.id == 'new') {
                window.open(redirectUrl, "_blank").focus();
                router.push({
                    name: 'payment-links-editor',
                    params: { id: paymentLinkId }
                });
            }
            else {
                window.open(redirectUrl, "_blank").focus();
            }
        }
        const validatePaymentLinkConfig = () => {
            if (!selectedProduct.value || Object.keys(selectedProduct.value).length === 0 ||
                !selectedPrice.value || Object.keys(selectedPrice.value).length === 0) {
                notification.error({
                    content: 'Please select product and price',
                    duration: 3000,
                    keepAliveOnHover: false,
                });
                return false;
            }
            if (isBrandingPresent.value) {
                if (!formValue.value.branding) {
                    notification.error({
                        content: 'Please add branding text',
                        duration: 3000,
                        keepAliveOnHover: false,
                    });
                    return false;
                }
            }
            if (!paymentLinkName.value) {
                notification.error({
                    content: 'Please give a link name',
                    duration: 3000,
                    keepAliveOnHover: false,
                });
                return false;
            }
            return true;
        };
        const onClickSave = async (redirectToPreview) => {
            try {
                if (!validatePaymentLinkConfig())
                    return;
                let productData = selectedProduct.value;
                productData.prices = [selectedPrice.value];
                const dataToSave = {
                    altId: route.params.location_id,
                    altType: 'location',
                    active: true,
                    captureCustomerAddress: showCustomerAddresses.value,
                    captureCustomerPhone: showPhoneNumber.value,
                    collectTax: false,
                    allowPromotionCodes: false,
                    paymentButtonText: selectedPayButton.value.value,
                    linkName: paymentLinkName.value,
                    products: [productData],
                    liveMode: liveMode.value,
                };
                const paymentLinkId = route.params.id;
                if (isBrandingPresent.value) {
                    dataToSave.branding = formValue.value.branding;
                }
                else {
                    dataToSave.branding = '';
                }
                let isPaymentLinkSavedSucessfully = false;
                if (paymentLinkId == 'new') { // create a new payment link
                    const { data, status } = await PaymentServices.createNewPaymentLink(dataToSave);
                    if (status == 200 || 201)
                        isPaymentLinkSavedSucessfully = true;
                    if (!redirectToPreview) {
                        router.push({
                            name: 'payment-links-editor',
                            params: { id: data.paymentLink._id }
                        });
                    }
                    else {
                        return data.paymentLink._id;
                    }
                }
                else { // update a payment link
                    const { data, status } = await PaymentServices.updatePaymentLink(paymentLinkId, dataToSave);
                    if (status == 200)
                        isPaymentLinkSavedSucessfully = true;
                    if (redirectToPreview) {
                        return data.paymentLink._id;
                    }
                }
                notification.success({
                    content: isPaymentLinkSavedSucessfully ? 'Payment link saved successfully' : 'Payment link not saved',
                    duration: 5000,
                    keepAliveOnHover: true
                });
            }
            catch (error) {
                console.log("Error in Saving the Payment Link");
                notification.error({
                    content: 'Unable to save the payment link',
                    duration: 3000,
                    keepAliveOnHover: true,
                });
            }
        };
        async function getPaymentLinkDetails(paymentLinkId) {
            const { data } = await PaymentServices.getPaymentLinkById(paymentLinkId);
            showPhoneNumber.value = data.captureCustomerPhone;
            showCustomerAddresses.value = data.captureCustomerAddress;
            selectedPayButton.value = { label: data.paymentButtonText, value: data.paymentButtonText };
            selectedProduct.value = products.value.find((item) => item._id == data.products[0]._id);
            selectedPrice.value = prices.value.find((item) => item._id == data.products[0].prices[0]._id);
            paymentLinkName.value = data.linkName || 'New Link';
            liveMode.value = data.liveMode;
            if (data?.branding) {
                isBrandingPresent.value = true;
                formValue.value.branding = data?.branding;
            }
            else {
                isBrandingPresent.value = false;
            }
        }
        onMounted(async () => {
            const paymentLinkId = route.params.id;
            await getProducts();
            if (paymentLinkId !== 'new') {
                await getPaymentLinkDetails(paymentLinkId);
            }
            else {
                formValue.value.branding = `Powered by ${rootStore.state.locations?.currentLocation?.name}`.substring(0, 40);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createVNode(_unref(UIToolbar), {
                        theme: 'light',
                        class: "pt-2 fixed w-full mt-0"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UIToolbarGroup), null, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIButton), {
                                        id: "btn-1",
                                        text: "",
                                        onClick: goBack
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(ChevronLeftIcon), { class: "w-8 h-8 text-black" }),
                                            _hoisted_2
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(UIToolbarGroup), null, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIInput), {
                                        id: 'payment-link-name',
                                        modelValue: paymentLinkName.value,
                                        "onUpdate:modelValue": [
                                            _cache[0] || (_cache[0] = ($event) => ((paymentLinkName).value = $event)),
                                            updatePaymentLinkName
                                        ],
                                        placeholder: 'Enter Link Name',
                                        type: 'text',
                                        size: 'medium',
                                        style: { "max-width": "150px" },
                                        class: "text-center pl-1"
                                    }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(UIToolbarGroup), { class: "flex items-end" }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIButton), {
                                        id: "product-editor-cancel",
                                        onClick: onClickPreview,
                                        disabled: false
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString("Preview"))
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(UIButton), {
                                        id: "product-editor-save",
                                        type: "primary",
                                        onClick: _cache[1] || (_cache[1] = () => onClickSave(false)),
                                        disabled: false,
                                        loading: false
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Save01Icon), { class: "h-4 w-4 mr-1" }),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t("common.save")), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", null, [
                                _createVNode(_unref(UIForm), {
                                    id: "payment-links-editor-form",
                                    ref: "root",
                                    model: formValue.value,
                                    showLabel: false
                                }, null, 8, ["model"]),
                                _createVNode(_unref(UITextSmNormal), null, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString('Product'))
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_unref(UISelect), {
                                    class: "mt-1",
                                    size: 'large',
                                    id: "select-product-id",
                                    "onUpdate:value": onClickProduct,
                                    placeholder: _ctx.$t('Select a Product'),
                                    value: selectedProduct.value.value,
                                    options: products.value
                                }, null, 8, ["placeholder", "value", "options"])
                            ]),
                            _createVNode(_unref(UITextSmNormal), { class: "mt-2" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString('Price'))
                                ]),
                                _: 1
                            }),
                            (_openBlock(), _createElementBlock("div", {
                                key: selectedProduct.value.value ? selectedProduct.value.value._id : 'default',
                                class: "mt-1"
                            }, [
                                _createVNode(_unref(UISelect), {
                                    id: selectedProduct.value.value ?? 'default',
                                    placeholder: _ctx.$t('Select a Price'),
                                    "onUpdate:value": onClickPrice,
                                    value: selectedPrice.value.value ? selectedPrice.value.value : null,
                                    options: prices.value
                                }, null, 8, ["id", "placeholder", "value", "options"])
                            ])),
                            _createVNode(_unref(UITextLgMedium), { class: "pt-3" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString('Options'))
                                ]),
                                _: 1
                            }),
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(UICheckbox), {
                                    id: `option1-checkbox`,
                                    class: "checkbox",
                                    checked: showPhoneNumber.value,
                                    "onUpdate:checked": capturePhoneNumber
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(" Require Customers to add a Phone Number ")
                                    ]),
                                    _: 1
                                }, 8, ["checked"]),
                                _createVNode(_unref(UICheckbox), {
                                    id: `option1-checkbox`,
                                    class: "checkbox",
                                    checked: showCustomerAddresses.value,
                                    "onUpdate:checked": captureCustomerAddresses
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(" Collect Customer Addresses ")
                                    ]),
                                    _: 1
                                }, 8, ["checked"])
                            ]),
                            _createVNode(_unref(UITextLgMedium), { class: "pt-3 pb-3" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString('Advance Options'))
                                ]),
                                _: 1
                            }),
                            _hoisted_7,
                            _createVNode(_unref(UISelect), {
                                id: 'select-pay-button',
                                options: _unref(payButtonOptions),
                                size: 'medium',
                                placeholder: 'Select Text For Payment Button',
                                value: selectedPayButton.value.value,
                                "onUpdate:value": updatePayButton,
                                class: _normalizeClass('pt-1 pb-3')
                            }, null, 8, ["options", "value"]),
                            _createVNode(_unref(UICheckbox), {
                                id: `option1-checkbox`,
                                class: "checkbox",
                                checked: isBrandingPresent.value,
                                "onUpdate:checked": updateCustomTextPresent
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(" Branding ")
                                ]),
                                _: 1
                            }, 8, ["checked"]),
                            (isBrandingPresent.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(_unref(UIFormItem), {
                                        path: "branding",
                                        style: { "--n-feedback-height": "0", "--n-blank-height": "0", "--n-label-height": "0" }
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(UIInput), {
                                                id: 'custom-text',
                                                modelValue: formValue.value.branding,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formValue.value.branding) = $event)),
                                                placeholder: 'Powered by GoHighLevel with Love',
                                                type: 'text',
                                                readonly: false,
                                                rows: 3,
                                                maxlength: 40,
                                                minlength: undefined,
                                                clearable: false,
                                                size: 'large',
                                                showCount: true
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('common.paymentMode')), 1),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('common.test')), 1),
                                _createVNode(_unref(UISwitch), {
                                    id: "paymentMode",
                                    disabled: false,
                                    value: liveMode.value,
                                    "onUpdate:value": updateLiveMode
                                }, null, 8, ["value"]),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('common.live')), 1)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_unref(UITextLgMedium), null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString('Preview'))
                                ]),
                                _: 1
                            }),
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", null, [
                                            _hoisted_18,
                                            _createElementVNode("div", _hoisted_19, _toDisplayString(selectedPrice.value.label), 1),
                                            (!selectedPrice.value?.trialPeriod)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                    _createTextVNode(_toDisplayString(selectedPriceSymbol.value) + _toDisplayString(selectedPrice.value.amount) + " ", 1),
                                                    (selectedPrice.value?.recurring?.interval)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                                            _createTextVNode(" per "),
                                                            _hoisted_22,
                                                            _createTextVNode(" " + _toDisplayString(selectedPrice.value?.recurring?.interval), 1)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                    _createElementVNode("div", _hoisted_24, _toDisplayString(`${selectedPrice.value.trialPeriod} ${selectedPrice.value.trialPeriod > 1 ? 'days' : 'day'} free`), 1),
                                                    _createElementVNode("div", _hoisted_25, _toDisplayString(`Then ${selectedPriceSymbol.value}${selectedPrice.value.amount} per ${selectedPrice.value?.recurring?.interval}`), 1)
                                                ])),
                                            (selectedPrice.value?.setupFee)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, " This Product has an additional setup fee of " + _toDisplayString(selectedPriceSymbol.value) + _toDisplayString(selectedPrice.value.setupFee), 1))
                                                : _createCommentVNode("", true),
                                            (productImage.value)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 3,
                                                    src: productImage.value,
                                                    alt: selectedProduct.value.name,
                                                    class: "h-60 w-60 md:h-80 md:w-96 mt-4 mb-2 md:mt-12 object-contain"
                                                }, null, 8, _hoisted_27))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (isBrandingPresent.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(formValue.value.branding), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("div", _hoisted_30, [
                                            _createElementVNode("div", _hoisted_31, [
                                                _createElementVNode("div", _hoisted_32, [
                                                    _createVNode(_unref(UIFormItem), {
                                                        label: 'First Name',
                                                        path: "firstname",
                                                        required: true,
                                                        style: { "--n-feedback-height": "0", "--n-blank-height": "0", "--n-label-height": "0", "padding-top": "8px" }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UIInput), {
                                                                placeholder: 'First Name',
                                                                id: 'user-address-firstname',
                                                                value: formValue.value.firstname,
                                                                "onUpdate:value": _cache[3] || (_cache[3] = ($event) => ((formValue.value.firstname) = $event))
                                                            }, null, 8, ["value"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("div", _hoisted_33, [
                                                    _createVNode(_unref(UIFormItem), {
                                                        label: 'Last Name',
                                                        path: "lastname",
                                                        required: true,
                                                        style: { "--n-feedback-height": "0", "--n-blank-height": "0", "--n-label-height": "0", "padding-top": "8px" }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UIInput), {
                                                                placeholder: 'Last Name',
                                                                id: 'user-address-lastname',
                                                                value: formValue.value.lastname,
                                                                "onUpdate:value": _cache[4] || (_cache[4] = ($event) => ((formValue.value.lastname) = $event))
                                                            }, null, 8, ["value"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ])
                                            ]),
                                            _createVNode(_unref(UIFormItem), {
                                                label: 'Email',
                                                path: "email",
                                                required: true,
                                                style: { "--n-feedback-height": "0", "--n-blank-height": "0", "--n-label-height": "0", "padding-top": "8px" }
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(UIInput), {
                                                        placeholder: 'abc@gmail.com',
                                                        id: 'user-email-address',
                                                        value: formValue.value.email,
                                                        "onUpdate:value": _cache[5] || (_cache[5] = ($event) => ((formValue.value.email) = $event))
                                                    }, null, 8, ["placeholder", "value"])
                                                ]),
                                                _: 1
                                            }),
                                            (showPhoneNumber.value)
                                                ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                                                    key: 0,
                                                    class: "mt-3",
                                                    label: 'Phone',
                                                    path: "phone",
                                                    required: showPhoneNumber.value,
                                                    style: { "--n-feedback-height": "0" }
                                                }, {
                                                    default: _withCtx(() => [
                                                        (showPhoneNumber.value)
                                                            ? (_openBlock(), _createBlock(_unref(UIInputPhone), {
                                                                key: 0,
                                                                id: "input-phone",
                                                                disabled: false,
                                                                "country-code": 'US'
                                                            }))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                }, 8, ["required"]))
                                                : _createCommentVNode("", true),
                                            (_openBlock(), _createElementBlock("div", {
                                                class: "pb-3 mt-3",
                                                key: `${liveMode.value}`
                                            }, [
                                                _createVNode(_unref(UIPaymentElement), {
                                                    ref: "paymentElementRef",
                                                    env: paymentElementEnv.value,
                                                    id: "payment-element",
                                                    altId: 'QoRFzMbmzaXP148MW9mN',
                                                    altType: "location",
                                                    liveMode: liveMode.value,
                                                    debug: true,
                                                    stripeOptions: stripeOptions.value
                                                }, null, 8, ["env", "liveMode", "stripeOptions"])
                                            ])),
                                            (showCustomerAddresses.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                    _createVNode(_unref(UIFormItem), {
                                                        label: "Address",
                                                        style: { "--n-feedback-height": "0" }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UIInput), {
                                                                placeholder: 'Address Line 1',
                                                                id: 'user-address-line1'
                                                            })
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(UIInput), {
                                                        placeholder: 'Address Line 2',
                                                        id: 'user-address-line2'
                                                    }),
                                                    _createElementVNode("div", _hoisted_35, [
                                                        _createElementVNode("div", _hoisted_36, [
                                                            _createVNode(_unref(UIInput), {
                                                                placeholder: 'City',
                                                                id: 'user-address-city'
                                                            })
                                                        ]),
                                                        _createElementVNode("div", _hoisted_37, [
                                                            _createVNode(_unref(UIInput), {
                                                                placeholder: 'State',
                                                                id: 'user-address-state'
                                                            })
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createVNode(_unref(UIButton), {
                                                id: 'paybutton',
                                                type: 'primary',
                                                text: false,
                                                class: "w-full mt-2"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(selectedPayButton.value.value), 1)
                                                ]),
                                                _: 1
                                            }),
                                            (selectedPrice.value?.trialPeriod)
                                                ? (_openBlock(), _createBlock(_unref(UITextXsRegular), {
                                                    key: 2,
                                                    class: "mt-2 text-center text-gray-500"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(`After your trial ends, you will be charged ${selectedPriceSymbol.value}${selectedPrice.value.amount}. You can always cancel before then.`), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (selectedPrice.value.type == 'recurring' && !selectedPrice.value?.trialPeriod)
                                                ? (_openBlock(), _createBlock(_unref(UITextXsRegular), {
                                                    key: 3,
                                                    class: "mt-2 text-center text-gray-500"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(`By confirming your subscription, you allow ${_unref(rootStore).state.locations?.currentLocation?.name} to charge you for future payments in accordance with their terms. You can always cancel your subscription.`), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
